import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Container } from '../../components/Layout';
import Title from '../../components/Header/parts/Title';
import { getMediumImage } from '../../utils/prismic';

const AssetContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Asset = styled.a`
  flex-basis: 33%;
  flex-grow: 1;

  position: relative;
  display: flex;
  width: 100%;
  max-width: 960px;
  margin: 0;
  border: 1px solid var(--color-level-2);
  box-shadow: inset 0px 0px 0px var(--size-space-small) transparent;
  padding: var(--size-space-large);
  transition: all 0.4s ease;
  background: ${props => props.background};
  > div {
    max-width: 100%;
    max-height: 100%;
    text-align: center;
    margin: auto;
  }
  img {
    max-width: 100%;
    height: auto;
    opacity: 0.6;
    transition: all 0.4s ease;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    text-align: center;
    bottom: var(--size-space-medium);
    opacity: 0;
    transform: translateY(40px);
    transition: all 0.8s cubic-bezier(0, 1, 0, 1);
    color: var(--color-primary-light);
  }
  &:hover {
    //box-shadow: inset 0px 0px 0px var(--size-space-small) var(--color-primary-light);
    border-color: var(--color-primary-light);
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      opacity: 1;
      transform: translateY(0px);
    }
    img {
      opacity: 1;
    }
  }
`;

const Download = ({ input }) => (
  <Container tyle="article" restrict>
    <Title
      title={input.primary.title.html}
      subtitle={input.primary.subtitle.html}
      description={input.primary.description.html}
      title_align={input.primary.align_text}
    />
    <AssetContainer>
      {input.items.map((item, index) => {
        const downloadLink = item.download.url
          ? item.download.url
          : item.file
          ? item.file.url
          : '';
        const imageSrc = item.file
          ? item.file.Thumbnail
            ? item.file.Thumbnail.url
            : item.file.url
          : '';
        const imageAlt = item.file
          ? item.file.Thumbnail
            ? item.file.Thumbnail.alt
            : item.file.alt
          : item.label;

        var assetBackground = `var(--color-level-1)`;
        switch (item.background) {
          case 'Light':
            assetBackground = `var(--color-level-5)`;
            break;
          case 'Dark':
            assetBackground = `var(--color-level-1)`;
            break;
          default:
            assetBackground = `var(--color-level-2)`;
        }

        return (
          <Asset
            key={index + item.label}
            href={downloadLink}
            target="_blank"
            background={assetBackground}
          >
            <h6>Download {item.label}</h6>
            <div>
              {item.file ? (
                <img
                  src={imageSrc}
                  alt={item.label || imageAlt}
                  width={getMediumImage(item.file.Thumbnail).width}
                  height={getMediumImage(item.file.Thumbnail).height}
                />
              ) : null}
            </div>
          </Asset>
        );
      })}
    </AssetContainer>
  </Container>
);

export default Download;

Download.propTypes = {
  input: PropTypes.object.isRequired,
};

//src={x.file.localFile.childImageSharp.fluid}
//<Img fluid={x.image.localFile.childImageSharp.fluid} />
